import { styled } from '@mui/material/styles';

export const AlertsContainer = styled('div')({
  width: '100%',
  minWidth: 0,
});

export const AlertsLocationContainer = styled('div', {
  shouldForwardProp: (p) => p !== 'locationOn',
})(({ theme, locationOn }) => ({
  backgroundColor: locationOn ? theme.palette.success.light : theme.palette.action.disabled,
  borderRadius: 10,
  maxWidth: 500,
  margin: '10px auto',
  padding: `5px 10px`,
  position: 'relative',

  '& .MuiIcon-root': {
    position: 'absolute',
    top: 10,
    left: 8,
    color: theme.palette.common.black,
  },
}));

export const AlertsLocationContent = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(3),

  '& p': {
    fontSize: 12,
    color: theme.palette.common.black,
  },
  '& .MuiFormControlLabel-label': {
    fontWeight: 'bold',
    color: theme.palette.grey[700],
    fontSize: 14,
  },
}));
